export default __webpack_public_path__ + "dcaebff42305d1db239befd3f61b75ad.png";